const messages = {
    accountBox: {
        title: "Nadzorna plošča",
        description: "Hitro spremljajte svoje promocije in točke.",
        button: "ODPRETI NADZORNO PLOŠČO",
    },
};

export default {
    messages,
};
